import { render, staticRenderFns } from "./tag-layout.vue?vue&type=template&id=6bd85faf&scoped=true"
import script from "./tag-layout.vue?vue&type=script&lang=js"
export * from "./tag-layout.vue?vue&type=script&lang=js"
import style0 from "./tag-layout.vue?vue&type=style&index=0&id=6bd85faf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd85faf",
  null
  
)

export default component.exports